import { moveElementToContainer } from "../utils/functions";

const categoryMenu = () => {

  setInterval(() => {
    // Move Category Menu after Slider in Home page
    const bodyClass = document.querySelector(".home-page"),
      catMenu = document.querySelector(".category-menu"),
      catMenuPosCheck = document.querySelector(".cat-menu-pos-check"),
      slider = document.querySelector("main.wrap .wrap .slideshow.home-slider-section");

    if (catMenu) {
      if (bodyClass) {
        if (!catMenuPosCheck) {
          moveElementToContainer(catMenu, slider);
          catMenu.classList.add("cat-menu-pos-check");
        }
      }
    }
  }, 100);
};

export default categoryMenu;

